import { ChangeDetectionStrategy,Component, Inject, OnInit, ElementRef} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'transfer-dialog',
  templateUrl: './transfer.dialog.html',
  styleUrls: ['./transfer.dialog.css']
})
export class TransferDialog implements OnInit {

  transferForm: UntypedFormGroup;
  transferControl = new UntypedFormControl();
  transferPoints: any[];

  private readonly triggerElementRef: ElementRef;
  private readonly matDialogRef: MatDialogRef<TransferDialog>;

  constructor(@Inject(MAT_DIALOG_DATA)
  public data: any,
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<TransferDialog>) {

    this.transferPoints = data.allowedTransferPoints;
    this.transferControl = new UntypedFormControl('', Validators.required);

    this.matDialogRef = dialogRef;
    this.triggerElementRef = data.trigger;
    this.transferForm = this.fb.group(
      {
        transfer: this.transferControl
      });
  }


  ngOnInit() {
    const matDialogConfig: MatDialogConfig = new MatDialogConfig();
    const rect = this.triggerElementRef.nativeElement.getBoundingClientRect();
    matDialogConfig.position = { left: `${rect.left}px`, top: `${rect.bottom}px` };
    matDialogConfig.width = '214px';
    matDialogConfig.height = '181px';
    this.matDialogRef.updateSize(matDialogConfig.width, matDialogConfig.height);
    this.matDialogRef.updatePosition(matDialogConfig.position);
  }

  create() {
    if (this.canCreate())
    {
      this.data.transferPoint = this.transferControl.value;
      this.dialogRef.close(this.data);
    }
  }

  canCreate() {
    return this.transferForm.valid;
  }

  cancel() {
    this.dialogRef.close();
  }
}
